import { cloudFortifiedFilter } from '@atlassian/amkt-addon-discovery';
import { useFeatureFlags, useStatsig } from '@atlassian/mpac-feature-flags';
import { UrlUtils } from '@atlassian/mpac-utils';
// @ts-expect-error [MC-2850] - TS2339 - Property 'Iterable' does not exist on type 'typeof import("/immutable/dist/immutable-nonambient")'.
import { Iterable, Map, Set } from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { Redirect } from 'react-router-dom';

import SEOFriendlyRedirect from '../../../../../../common/components/SEOFriendlyRedirect';
import AmktCommonPropTypes from '../../../../../constants/PropTypes';
import { toAddonDiscoveryAppMappings, toAddonDiscoverySortMappings } from '../constants/mappings';
import * as perspectives from '../constants/perspectives';
import AddonDiscoveryWrapper from './AddonDiscoveryWrapper';

const silterMappings = toAddonDiscoverySortMappings
  .map((sm) => Map({ sort: sm }))
  .merge(
    Map({
      'cloud-fortified': cloudFortifiedFilter,
    })
  );

const resolvePathFilter = ({ defaultFilterKey, mappings, pathParam }) =>
  pathParam ? mappings.get(pathParam) || Map({ [defaultFilterKey]: pathParam }) : Map();

// JSD JSM migration
const homePageRedirectionMap = {
  jsd: 'jsm',
  'jira-service-desk': 'jira-service-management',
} as const;

const AddonDiscoveryRouteProcessor = (props) => {
  const { enableJsdToJsm, showAiAppsCollectionTile } = useFeatureFlags();
  const { showChangemakersCollectionTile } = useStatsig();
  const showChangemakersCollectionTileFlag = showChangemakersCollectionTile();
  const { match } = props;

  const resolveFilters = () => {
    return UrlUtils.resolveImmutableQuery(props.location.search)
      .update('product', (productFilter) => props.match.params.application || productFilter)
      .update(
        'product',
        (productFilter: any) =>
          toAddonDiscoveryAppMappings({ enableJsdToJsm }).get(productFilter) || productFilter
      )
      .mergeWith(
        (previous, next) =>
          Iterable.isIterable(next)
            ? (Iterable.isIterable(previous) ? previous : Set([previous]))
                // @ts-expect-error [MC-2850] - TS2339 - Property 'merge' does not exist on type 'string | Set<ImmutableQueryValue>'.
                .merge(next)
            : next,
        resolvePathFilter({
          defaultFilterKey: 'sort',
          mappings: silterMappings,
          pathParam: props.match.params.silter,
        })
      );
  };
  const filters = resolveFilters();

  // JSD JSM migration (Temp changes to support FF based redirection) -- Start
  if (enableJsdToJsm) {
    // handles redirection for mpac home page
    if (homePageRedirectionMap[props.match.params.application]) {
      return (
        <Redirect
          to={{
            ...props.location,
            pathname: props.location.pathname.replace(
              props.match.params.application,
              homePageRedirectionMap[props.match.params.application]
            ),
          }}
        />
      );
    }

    if (props.location.pathname.includes('/search')) {
      const params = new URLSearchParams(props.location.search);
      const selectedProduct = params.get('product');
      // handles redirection for search page
      if (selectedProduct?.includes('jira-service-desk')) {
        return (
          <Redirect
            to={{
              ...props.location,
              search: props.location.search.replace('jira-service-desk', 'jira-service-management'),
            }}
          />
        );
      } else if (selectedProduct?.includes('jsd')) {
        return (
          <Redirect
            to={{
              ...props.location,
              search: props.location.search.replace('jsd', 'jsm'),
            }}
          />
        );
      }
    }
  }
  // JSD JSM migration Temp changes to support FF based redirection -- End

  if (match.params.silter === 'verified') {
    return (
      <SEOFriendlyRedirect
        to={{
          ...props.location,
          pathname: props.location.pathname.replace('verified', 'top-vendor'),
        }}
        statusCode={301}
      />
    );
  }
  return (
    <AddonDiscoveryWrapper
      filters={filters}
      history={props.history}
      perspective={props.perspective}
      enableJsdToJsm={enableJsdToJsm}
      showAiAppsCollectionTile={showAiAppsCollectionTile}
      showChangemakersCollectionTileFlag={showChangemakersCollectionTileFlag}
    />
  );
};

AddonDiscoveryRouteProcessor.propTypes = {
  history: AmktCommonPropTypes.history.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired,
  }).isRequired,
  perspective: perspectives.propType.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      application: PropTypes.string,
      silter: PropTypes.string,
    }),
  }).isRequired,
};

export default AddonDiscoveryRouteProcessor;
